"use client"
import { useState } from 'react';
import Link from 'next/link';
import { PrismicNextImage } from '@prismicio/next';
import { Content } from '@prismicio/client';
import Button from '@aura-design/system/button';
import { HamburgerMenuIcon, Cross1Icon } from '@radix-ui/react-icons';

import Menu from '@/components/Menu';

type HeaderProps = {
  menu: Content.NavigationDocument;
};

const Header = ({ menu }: HeaderProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  if(!menu) return <></>;


  return (
    <header className="aura absolute left-0 right-0 top-0 z-40 bg-transparent">
      <div className="wall-pad">
        <ul className="nav-list">
          <li className="logo-circle">
            <Link href="/" className="nav-list cursor-pointer">
              <div className="valign item mt-[6.5px]">
                <PrismicNextImage field={menu.data.logo} fallbackAlt="" />
              </div>
            </Link>
          </li>
          <li className="hide-large">
            <Button
              mode="link"
              className="text-white"
              onClick={() => setIsOpen(true)}
            >
              <HamburgerMenuIcon className="icon" />
            </Button>
          </li>
          <li className="hide-small hide-medium">
            <ul className="nav-list">
              <Menu menu={menu} />
            </ul>
          </li>
        </ul>
      </div>
      <div
        className={`modal-menu anchor fluid vfluid hold left top right bottom snow aura ${
          !isOpen ? 'hidden' : 'active'
        }`}
      >
        <ul className="mod-detail top right left bottom aureole one g0 centertxt square">
          <ul className="nav-list">
            <li></li>
            <li></li>
            <li className="item">
              <Button mode="pill" onClick={() => setIsOpen(false)}>
                <Cross1Icon className="icon" />
              </Button>
            </li>
          </ul>
          <Menu menu={menu} onClose={() => setIsOpen(false)} isMobile />
        </ul>
      </div>
    </header>
  );
};

export default Header;
